// src/pages/devioz/DeviozLayout.tsx
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { Suspense, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import ColorAdminShell from '../../components/ColorAdminShell';

const BASE_TITLE = 'Devioz Admin';

export default function DeviozLayout() {
  const { user, ready } = useAuth();
  const location = useLocation();

  // Asegura clases base del tema y título por defecto
  useEffect(() => {
    document.title = BASE_TITLE;

    // Color Admin suele requerir estas clases en <body>
    const body = document.body;
    body.classList.add('app', 'app-header-fixed', 'app-sidebar-fixed');

    // Limpieza al desmontar (por si cambias de layout)
    return () => {
      body.classList.remove('app', 'app-header-fixed', 'app-sidebar-fixed');
    };
  }, []);

  if (!ready) {
    // Loader nativo del tema
    return (
      <div id="loader" className="app-loader">
        <span className="spinner" />
      </div>
    );
  }

  if (!user) {
    // Sin sesión -> login
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return (
    <ColorAdminShell title={BASE_TITLE}>
      <Suspense fallback={
        <div className="p-3 text-muted small">Cargando módulo…</div>
      }>
        <Outlet />
      </Suspense>
    </ColorAdminShell>
  );
}
